import React, { useState } from 'react';
import { Translate } from '../../language';
import logoRecoverPassword from '../../img/logo_final_png.png';
import ViewLogin from '../../containers/ViewLogin/ViewLogin';
import { connect } from 'react-redux'
import { sendRecoverUser } from '../../actions/recoverActions'

const RecoverPasswordChange = ({ history, sendRecoverUser, model, location }) => {
    var email = location.state.email
    var code = location.state.code
    const [password, setPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)


    const isFocused = (e) => {

    }


    const isEmpty = (e) => {
        const { name, placeholder, value } = e.target;
        if (name === "password")
            setPassword(value)
        if (name === "confirmPassword")
            setConfirmPassword(value)
        console.log()
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        else {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));

            if (name === "password") {
                if (value.length < 6) {
                    setValidate(false)
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('passwordToShort', 'es')
                    }));
                }

                if (value.length > 32) {
                    setValidate(false)
                    setError(prevError => ({
                        ...prevError,
                        [name]: Translate('passwordToLong', 'es')
                    }));
                }
            }

            if (
                name === "confirmPassword" && value !== password ||
                name === "password" && value !== confirmPassword

            ) {
                setValidate(false)
                setError(prevError => ({
                    ...prevError,
                    ["confirmPassword"]: Translate('passwordNoMatch', 'es')
                }));
            }
            else {
                setValidate(true)
                setError(prevError => ({
                    ...prevError,
                    ["confirmPassword"]: ''
                }));
            }
        }

    }

    const goToLogin = (e) => {
        e.preventDefault()

        sendRecoverUser(email, password, code, history)

        history.push('/')
    }

    return (
        <ViewLogin
            type='password'
            nameInput='password'
            nameInputPassword='confirmPassword'
            img={logoRecoverPassword}
            textWelcome={Translate('messageRecoverPassword', 'es')}
            inputValue={password}
            error={error.password}
            errorPassword={error.confirmPassword}
            onChangeInput={isEmpty}
            onFocusInput={isFocused}
            inputPlaceholder="newPassword"
            nputValuePassword={confirmPassword}
            inputPlaceholderPassword="confirmNewPassword"
            textButton="send"
            actionButton={goToLogin}
            textDown=''
            TextlinkDown=''
            linkToDown=''
            isMenuDown={false}
            isBackgroundBlue={false}
            isActiveButton={isValidate}
            isConfirmationPassword={true}
        />
    )
}

const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        userEmail: state.recover.email, // y lo que retorna map, connect lo envia a Page como Props 
        isLoading: state.recover.isLoadingViewRecoverCode,
        loginEmail: state.register.loginEmail,
        code: state.recover.code,
        model: state.recover.model

    }
}

export default connect(mapStateToProps, { sendRecoverUser })(RecoverPasswordChange)
